import { createUserManager } from 'redux-oidc';
import buildRedirectUri from './buildRedirectUri';

const keycloakUserManagerConfig = {
  client_id: 'business-portal',
  redirect_uri: buildRedirectUri('/auth/keycloak/login_redirect?flow=keycloak'),
  authority: process.env.REACT_APP_API_URL_KEYCLOAK_AUTH,
  scope: 'openid profile email',
  response_type: 'code',
  silent_redirect_uri: buildRedirectUri('/auth/keycloak/silent_renew'),
  post_logout_redirect_uri: buildRedirectUri('/auth/keycloak/logout_redirect'),
};

const keycloakUserManager = createUserManager(keycloakUserManagerConfig);

keycloakUserManager.events.addAccessTokenExpiring(() => {
  console.log('keycloak token expiring...');
});

keycloakUserManager.events.addUserSignedOut(() => {
  keycloakUserManager.signinRedirect();
});

export default keycloakUserManager;
